import { render } from "./dashboard-events-chart.vue?vue&type=template&id=b8ec18bc&ts=true"
import script from "./dashboard-events-chart.ts?vue&type=script&lang=ts"
export * from "./dashboard-events-chart.ts?vue&type=script&lang=ts"

import "./dashboard-events-chart.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__